import { useState, useCallback } from 'react';
import GoogleTranslateService from 'services/gTranslate/google-translate-service';

const useGoogleTranslate = () => {

	const [isTranslationLoading, setIsTranslationLoading] = useState(true);
	const [translationData, setTranslationData] = useState(null);
	const [translationNotFound, setTranslationNotFound] = useState(false);

	const loadTranslation = useCallback(async (array) => {
		try {
			const result = await GoogleTranslateService.translate(array);
			const translations = result?.data?.data?.translations;
			if (!Array.isArray(translations)) {
				setTranslationNotFound(true);
				setTranslationData(array.map(() => null));
				return;
			}
			setTranslationData(translations.map((item) => item?.translatedText || null));
		} catch (err) {
			setTranslationNotFound(true);
			setTranslationData(array.map(() => null));
		} finally {
			setIsTranslationLoading(false);
		}
	}, []);

	return {
		isTranslationLoading,
		translationNotFound,
		translationData,
		loadTranslation
	};
};

export default useGoogleTranslate;